export default __webpack_public_path__ + "static/media/contact.cdf3239f.png";